import { Injectable } from '@angular/core';
import { StrapiCollectionEntityByCityApiService } from '@core/data-access';
import { ProductRecommendationEntity, ProductRecommendationEntityStrapi } from '@product/const/v2';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductRecommendationApiService extends StrapiCollectionEntityByCityApiService<ProductRecommendationEntityStrapi> {
  constructor() {
    super('product-recommendations', 'citiesIncluded', 'citiesExcluded');
  }

  getProductRecommendationData(baseStoreCode: string): Observable<ProductRecommendationEntity[] | null> {
    return this.getListByCity({}, baseStoreCode).pipe(
      map((productRecommendations) => {
        if (!productRecommendations.length) return null;

        return productRecommendations.map((recommendation) => ({
          page: recommendation.page,
          carouselType: recommendation.carouselType,
          title: recommendation.title,
          productCodes: recommendation.productCodes,
          algorithms: recommendation.algorithms || [],
          itemLimits: recommendation.itemLimits,
        }));
      }),
    );
  }
}
